module.exports = __webpack_public_path__ + "img/avatar1.03aad932.jpg";